// src/App.js
import React, { Suspense } from "react";
import { Routes } from "react-router-dom";

import "./App.css";
import RouteLoadingFallback from "./components/RouteLoadingFallback";
import { renderPublicRoutes } from "./app/routes/publicRoutes";
import { renderIcvRoutes } from "./app/routes/icvRoutes";
import { renderTimker2Routes } from "./app/routes/timker2Routes";
import { renderAdminRoutes } from "./app/routes/adminRoutes";
import { renderNotFoundRoutes } from "./app/routes/notFoundRoutes";

/**
 * Application composition root.
 * Detail route, lazy-loading, dan guard dipisah per domain agar App tetap kecil.
 */
function App() {
  return (
    <Suspense fallback={<RouteLoadingFallback />}>
      <Routes>
        {renderPublicRoutes()}
        {renderIcvRoutes()}
        {renderTimker2Routes()}
        {renderAdminRoutes()}
        {renderNotFoundRoutes()}
      </Routes>
    </Suspense>
  );
}

export default App;
